import React from 'react'
import ModalAddUser_Left from "./left/left"
import {AddUser_Manager} from "../model/manager"
import ModalAddUser_Right from "./right/right"
import {useForceUpdate} from "../../../gd/utils/dom-and-react/react-utils";

// const debug = "ModalAddUser_Main"
const debug = false

type Props = {
    manager: AddUser_Manager
}

export default function ModalAddUser_Main(props:Props) {

    props.manager.reRender = useForceUpdate()

    return (
        <>
            <ModalAddUser_Left manager={props.manager}/>
            <ModalAddUser_Right manager={props.manager}/>
        </>
    )
}